/**
 * Human labels for the firm roles (design-system.md §15: sentence case, precise terms).
 * Every screen that prints a role goes through this — never `role.replace(/_/g, ' ')`.
 */
import type { Role } from '@argus/permissions-catalogue';

const LABELS: Record<Role, string> = {
  managing_partner: 'Managing partner',
  firm_admin: 'Firm admin',
  senior_associate: 'Senior associate',
  associate: 'Associate',
  paralegal: 'Paralegal',
  client: 'Client',
};

export function formatRole(role: Role | string | null | undefined): string {
  if (!role) return '';
  return (LABELS as Record<string, string>)[role] ?? role.replace(/_/g, ' ');
}
